/* eslint-disable camelcase */
import MealChoiceCard from './MealChoiceCard';

function MealsGroup({ title, desc, meals = [], checkedDates = [], onToggle, disabled = false }) {
    if (!meals.length) return null;

    return (
        <section className="meals-group">
            <div className="meals-group__header">
                <div className="meals-group__heading">
                    <h3 className="meals-group__title">{title}</h3>
                    {desc && <p className="meals-group__desc">{desc}</p>}
                </div>
            </div>

            <div className="meals-choice-grid">
                {meals
                    .slice()
                    .sort((a, b) => Number(a.dato) - Number(b.dato))
                    .map(meal => (
                        <MealChoiceCard
                            key={`${title}-${meal.dato}`}
                            meal={meal}
                            label={title}
                            checked={checkedDates.includes(meal.dato)}
                            onToggle={() => onToggle(meal.dato)}
                            disabled={disabled}
                        />
                    ))}
            </div>
        </section>
    );
}

export default MealsGroup;
